module.exports = __webpack_public_path__ + "static/media/humburger.8fa605f8.png";